window.addEventListener('load', function () {
  
    // Create a MutationObserver using jQuery
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function () {
            const cookieBanner = $('#shopify-pc__banner');
            if (cookieBanner.length) {
                customizeCookieBanner();
                observer.disconnect(); // Stop observing once the banner is customized
            }
        });
    });

    // Start observing changes in the document body
    observer.observe(document.body, { childList: true, subtree: true });

    function customizeCookieBanner() {
        // Target the Accept button
        const $acceptButton = $('#shopify-pc__banner__btn-accept');
        const $declineButton = $('#shopify-pc__banner__btn-decline');
        const $managePrefsButton = $('#shopify-pc__banner__btn-manage-prefs');

        if ($acceptButton.length) {
            $acceptButton.text('Accept All Cookies');

            $acceptButton.css({
                'background-color': 'black',
                'color': 'white'
            });

            $acceptButton.hover(
                function () {
                    $(this).css('background-color', 'grey');
                },
                function () {
                    $(this).css('background-color', 'black');
                }
            );
        }

        if ($declineButton.length && $managePrefsButton.length) {
            $declineButton.text('Manage Preferences');

            $declineButton.on('click', function (e) {
                e.preventDefault();
                $managePrefsButton.click();
            });

            $managePrefsButton.hide();
        }

        $('#shopify-pc__banner').css({
            'width': '100%',
            'max-width': '100%',
            'left': '0',
            'right': '0',
            'bottom': '0',
            'top': 'auto',
            'position': 'fixed',
            'transform': 'none',
            'border-radius': '0',
            'box-shadow': 'none',
            'z-index': '9999',
            'box-shadow': '0 -4px 6px rgba(0, 0, 0, 0.1)' 
        });

    }
});